<template>
  <el-form class="el-form-browser" :model="form" ref="form" :rules="rules">
    <el-form-item prop="url">
      <el-input type="text" v-model="form.url" placeholder="请输入访问地址"></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import {formValid} from '@/utils/form'
import {regex} from '@/utils/regex'
export default {
  name: 'yblBrowser',
  data () {
    return {
      form: {
        url: ''
      },
      rules: {
        url: [{required: true, message: '请输入访问地址'}, {validator: formValid.validInputByReg, message: '输入的访问地址格式不对', reg: regex.url}]
      }
    }
  },
  methods: {
    changeLocation () {
      const reg = /^\/|(http(s)?:\/\/)|\/$/g
      const url = this.form.url
      const {protocol} = window.location
      window.location.href = `${protocol}//${url.replace(reg, '')}`
    },
    submit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.changeLocation()
        }
      })
    }
  }
}
</script>

<style lang="less">
.el-form-browser{
  .el-form-item .el-input{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/browser.vue